module.exports = __webpack_public_path__ + "img/businessman.043c78c3.svg";